import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from 'atomiccomponents-react-ui';
import './index.css';
import App from './App';

// Register Atomic UI license from environment variable
if (process.env.REACT_APP_ATOMIC_UI_LICENSE) {
  window.ATOMIC_UI_LICENSE = process.env.REACT_APP_ATOMIC_UI_LICENSE;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
